export default __webpack_public_path__ + "static/media/Manhattan Associates.14fc465c.png";